export enum ReportsOrderSortField {
    ORDER_DATE = 'ORDER_DATE',
    ORDER_ID = 'ORDER_ID',
    SUBTOTAL = 'SUBTOTAL',
    TOTAL = 'TOTAL',
    DISCOUNT_AMOUNT = 'DISCOUNT_AMOUNT',
    DISCOUNT_NAME = 'DISCOUNT_NAME',
    TENDER_NAME = 'TENDER_NAME'
}